import { render, staticRenderFns } from "./BlockType8.vue?vue&type=template&id=3477dec0&scoped=true"
import script from "./BlockType8.vue?vue&type=script&lang=ts"
export * from "./BlockType8.vue?vue&type=script&lang=ts"
import style0 from "./BlockType8.vue?vue&type=style&index=0&id=3477dec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477dec0",
  null
  
)

export default component.exports